import React, { useRef, useEffect } from 'react'
import { DialogOverlay, useOverlay, Avatar, Row } from '@fs/zion-ui'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'
import { trackEvent } from '@fs/zion-analytics'
import { getSessionId } from '@fs/zion-session'
import StationSignOutBox from './StationSignOutBox'
import { useGetKeepsakes } from '../../../keepsakes/hooks/hooks'
import TakeAwayImage from '../TakeAwayImage/TakeAwayImage'
import TakeAwaysList from './TakeAwaysList'

const downloadHeaderCSS = css`
  height: 50px;
  background-color: #8dbd4a;
  display: flex;
  align-items: center;
`

const downloadHeaderLabelCSS = css`
  display: inline-block;
  font-family: Verdana, sans-serif;
  font-size: 20px;
  padding: 15px;
`

const profileStyles = css`
  display: flex;
  align-items: center;
  border: none;
  padding: 0.5rem;
  background-color: #fff;
`

export default function KioskDrawer({
  logoutCallback,
  email,
  userDisplayName,
  userPortrait,
  userGender,
  requestKeepsakesImmediately = false,
}) {
  const [t] = useTranslation()
  const dialogOpener = useOverlay()
  const [selected, setSelected] = React.useState()
  const [drawerState, setDrawerState] = React.useState({
    bottom: false,
    right: false,
    top: false,
    left: false,
  })
  const [getKeepsakes, getKeepsakesState] = useGetKeepsakes()

  const toggleFunc = useRef((side, open) => () => {
    trackEvent({ event_name: 'KioskDrawer:TOGGLE_DRAWER:CLICK', open: open ?? false })
    if (open) {
      getKeepsakes(getSessionId())
    }
    setDrawerState({ ...drawerState, [side]: open })
  })

  const drawerContentsCSS = css`
    background-color: #999999;
    height: 100vh;
    width: 450px;
    display: flex;
    flex-direction: column;
  `

  useEffect(() => {
    if (requestKeepsakesImmediately) {
      getKeepsakes(getSessionId())
    }
  }, [getKeepsakes, requestKeepsakesImmediately])

  return (
    <>
      <div>
        {userDisplayName && (
          <button
            data-testid="user-display-name-button"
            css={profileStyles}
            type="button"
            onClick={toggleFunc.current('right', true)}
          >
            <Row alignY="middle">
              <Avatar size="sm" src={userPortrait} sex={userGender} />
              <span>{userDisplayName}</span>
            </Row>
          </button>
        )}
      </div>
      <SwipeableDrawer
        open={drawerState.right}
        onClose={toggleFunc.current('right', false)}
        onOpen={toggleFunc.current('right', true)}
        anchor="right"
        disableSwipeToOpen
      >
        <div css={drawerContentsCSS}>
          <StationSignOutBox logoutCallback={logoutCallback} toggleDrawer={toggleFunc.current} email={email} />
          <div css={downloadHeaderCSS}>
            <span css={downloadHeaderLabelCSS}>{t('station.downloads', 'Downloads')} </span>
          </div>
          <TakeAwaysList
            takeAwayListData={getKeepsakesState?.response?.[0]}
            opened={drawerState.right}
            dialogOpener={dialogOpener}
            toggleDrawer={toggleFunc.current('right', false)}
            setSelected={setSelected}
          />
        </div>
      </SwipeableDrawer>
      <DialogOverlay title=" " {...dialogOpener}>
        {selected?.type === 'video' ? (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video controls src={selected?.url} style={{ width: '100%' }} />
        ) : (
          <TakeAwayImage takeAway={selected} style={{ width: '100%' }} />
        )}
      </DialogOverlay>
    </>
  )
}

KioskDrawer.propTypes = {
  logoutCallback: func,
}
